import './userWidget.css';

import DefaultUserIcon from '../../assets/icons/defaultUserIcon/defaultUserIcon';

export default function UserWidget({user}) {
    return (
        <div>
            <div className="user-widget-container">
                <DefaultUserIcon />
                <div className="user-widget-info">
                    <p>{`${user.first_name} ${user.last_name}`}</p>
                    <p>{`${user.user_email}`}</p>
                </div>
            </div>
        </div>
    )
};